import React, { useState, createRef, useEffect } from 'react';
import './../customer/tailwind.min.css';
import './../customer/verifications.css';
import { Link, useNavigate } from 'react-router-dom';
import Api from '../common/Api.js';
import jwt_encode from 'jwt-encode';
import jwt_decode from 'jwt-decode';
import SweetAlert2 from 'react-sweetalert2';

function FranchiseeVerifications() {
  const navigate = useNavigate();

  // Set to true once OTP verification succeeds, so the guard below
  // doesn't bounce us back to /franchisee-register while the alert is up.
  const [verified, setVerified] = useState(false);

  // SweetAlert config
  const [swalProps, setSwalProps] = useState({});

  useEffect(() => {
    if (verified) return;                                    // post-success — don't redirect
    if (localStorage.getItem('franchisee-otp-token') === null) {
      navigate('/franchisee-register');
      return;
    }
    if (localStorage.getItem('franchisee-token') !== null) {
      navigate('/franchisee-dashboard');
    }
  });

  const [value, setJSON] = useState(JSON.parse(localStorage.getItem('franchisee-otp-token')));
  const [values, setValues] = useState({ first: '', second: '', third: '', fourth: '', fifth: '', sixth: '' });
  const [inputRefsArray] = useState(() => Array.from({ length: 6 }, () => createRef()));
  const [res_errors, setRes_errors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [resend, setResend] = useState();

  const handleChange = (event) => {
    const index = Number(event.target.id);
    setValues((v) => ({ ...v, [event.target.name]: event.target.value }));

    const nextInput = inputRefsArray?.[index < 5 ? index + 1 : 0]?.current;
    const currentInput = inputRefsArray?.[index]?.current;
    const prevInput = inputRefsArray?.[index - 1]?.current;

    if (event.key === 'Backspace') {
      currentInput.value = '';
      if (index !== 0) prevInput.focus();
      setValues((v) => ({ ...v, [currentInput.name]: '' }));
      event.preventDefault();
    } else if (event.keyCode > 47 && event.keyCode < 58) {
      currentInput.value = event.key;
      if (index !== 5) nextInput.focus();
      setValues((v) => ({ ...v, [currentInput.name]: event.key }));
      currentInput.style = '';
      event.preventDefault();
    } else if (event.keyCode > 64 && event.keyCode < 91) {
      currentInput.value = '';
      setValues((v) => ({ ...v, [currentInput.name]: '' }));
      event.preventDefault();
    }
  };

  const handleSubmit = async (event) => {
    if (event) event.preventDefault();
    if (!validate()) return;

    setLoading(true);
    const send = { id: value.id, mobile: value.mobile, otp: values };

    try {
      const res = await Api.post('/franchisee/check', jwt_encode(send, process.env.REACT_APP_SECRET_KEY));
      const result = jwt_decode(res.data);
      setLoading(false);

      if (result.data.status === 'failure') {
        setRes_errors(result.data.errors || {});
        setTimeout(() => setRes_errors([]), 10000);
      } else {
        // ── SUCCESS — do NOT log the user in ──────────────────────────────
        // Remove the temporary OTP session; leave franchisee-token unset
        // so the rest of the app treats this user as logged out.
        localStorage.removeItem('franchisee-otp-token');

        // Stop the guard above from redirecting back to /franchisee-register
        setVerified(true);

        // Show the "pending admin approval" alert
        setSwalProps({
          show: true,
          title: 'Registration Successful',
          text: 'Your franchisee verification is underway. If it takes longer than expected, please contact our support team.',
          icon: 'success',
          confirmButtonText: 'OK',
          confirmButtonColor: '#f85c70',
          allowOutsideClick: false,
          allowEscapeKey: false,
          didClose: () => {
            setSwalProps({ show: false });
            navigate('/');                                   // go home
          },
        });
      }
    } catch {
      setLoading(false);
      setRes_errors({ msg: 'Something went wrong. Please try again.' });
    }
  };

  const handleResend = async () => {
    const send = { id: value.id, mobile: value.mobile };
    try {
      const res = await Api.post('/franchisee/resend', jwt_encode(send, process.env.REACT_APP_SECRET_KEY));
      const result = jwt_decode(res.data);

      if (result.data.status === 'failure') {
        setRes_errors(result.data.errors || {});
        setTimeout(() => setRes_errors([]), 8000);
      } else {
        setValues({ first: '', second: '', third: '', fourth: '', fifth: '', sixth: '' });
        localStorage.setItem('franchisee-otp-token', JSON.stringify(result.data.data));
        setJSON(result.data.data);
        setResend(result.data.message);
        setTimeout(() => setResend(null), 5000);
      }
    } catch {
      setRes_errors({ msg: 'Could not resend OTP.' });
    }
  };

  const validate = () => {
    let ok = true;
    ['first', 'second', 'third', 'fourth', 'fifth', 'sixth'].forEach((k, i) => {
      if (!values[k] || values[k].trim().length === 0) {
        const el = inputRefsArray?.[i]?.current;
        if (el) el.style = 'border: 1px solid red';
        ok = false;
      }
    });
    return ok;
  };

  return (
    <>
      {/* SweetAlert2 — opens when swalProps.show is true */}
      <SweetAlert2 {...swalProps} />

      <section className="w3l-forms-23">
        <div className="forms23-block">
          <div className="wrapper">
            <h1>
              <Link to="#." className="logo-2" style={{ color: '#ffffff', fontWeight: '700' }}>
                DLMP21
              </Link>
            </h1>
            <div className="d-grid forms23-grids">
              <div className="form23">
                <h6 className="text-center">Verify your Shop</h6>
                <p className="text-center">
                  Enter the OTP sent on <strong>{value.mobile}</strong> below.
                </p>
                {value.valid && (
                  <p className="text-center">
                    <small className="text-info">* OTP valid till <strong>{value.valid}</strong></small>
                  </p>
                )}
                <br />
                <form onSubmit={handleSubmit}>
                  <div className="mb-6 text-center">
                    <div id="otp" className="flex justify-center">
                      {inputRefsArray.map((ref, index) => {
                        const name = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth'][index];
                        return (
                          <input
                            key={index}
                            type="tel"
                            pattern="[0-9]{1}"
                            id={index}
                            name={name}
                            value={values[name]}
                            maxLength="1"
                            ref={ref}
                            autoFocus={index === 0}
                            onKeyDown={handleChange}
                            onChange={handleChange}
                            className="m-2 text-center form-control form-control-solid rounded focus:border-blue-400 focus:shadow-outline"
                            style={{ padding: 'unset' }}
                          />
                        );
                      })}
                    </div>
                    {res_errors.msg && <small className="text-danger">{res_errors.msg}</small>}
                    {resend && <small className="text-success">{resend}</small>}
                  </div>

                  <button type="submit" className="btn button-eff" style={{ padding: 'unset', height: '40px' }}>
                    <span style={{ marginLeft: '35px' }}>Submit</span>
                    <span style={{ float: 'right', width: '10px', height: '10px', marginLeft: '5px' }}>
                      {loading && <i className="fa fa-circle-o-notch fa-spin"></i>}
                    </span>
                  </button>

                  <p className="text-center">
                    <small>
                      * OTP not received..{' '}
                      <Link onClick={handleResend} style={{ color: 'green' }} to="#">
                        Resend OTP now !!!
                      </Link>
                    </small>
                  </p>
                </form>
              </div>

              <div className="form23-text">
                <h3>Buy, Sell, Find, Shop Ads, Rent & Exchange in one Click</h3>
                <p>Our jobs as marketers are to understand how the customer wants to buy and help them to do so.</p>
                <Link to="/" className="btn button-eff button-eff-2">
                  <span className="fa fa-hand-o-left" aria-hidden="true"></span> Back to Home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default FranchiseeVerifications;